<template>
  <div class="skill">
    <h1 @click="toSkill">技术</h1>
    <div class="skill-content">
      移动边缘计算（Mobile Edge Computing, MEC），是未来第五代移动通信(5G)的关键技术，可利用无线接入网络就近提供电信用户IT所需服务和云端计算功能， 
      而创造出一个具备高性能、低延迟与高带宽的电信级服务环境， 加速网络中各项内容、服务及应用的快速下载，让消费者享有不间断的高质量网络体验。
    </div>
    <div class="img-boxs"></div>
  </div>
</template>

<script>
export default {
  methods: {
    toSkill() {
      location.href="technology.html"
    }
  }
}
</script>


<style lang="scss" scoped>
  .skill {
    padding-top: 100px;
    width: 100%;
    background-color: #F7F8FA;
    text-align: center;
    position: relative;
    height: 898px;
    box-sizing: border-box;
    h1 {
      color: #2C3B5C;
      font-size: 36px;
      line-height: 36px;
      margin-bottom: 30px;
      cursor: pointer;
    }
    .skill-content {
      /* width: 658px; */
      width: 804px;
      margin: 0 auto;
      line-height: 28px;
      color: #555E73;
      font-size: 16px;
    }
    .img-boxs {
      width:889px;
      height:768px;
      position: absolute;    
      left: 50%;
      transform: translateX(-50%);
      top: 130px; 
      background: url('~static/img/index/MEC_pic.png') no-repeat center;
      background-size: cover;
    }
  }
</style>




// WEBPACK FOOTER //
// src/components/index/skill.vue